import { z } from "zod";
export const ComponentRoleSchema = z.enum([
    "pageShell",
    "topbar",
    "nav",
    "hero",
    "trustBar",
    "primaryCTA",
    "services",
    "serviceList",
    "productGrid",
    "menuSection",
    "eventSchedule",
    "speakerGrid",
    "trust",
    "proof",
    "proofBlock",
    "testimonialBlock",
    "credentialBlock",
    "processTimeline",
    "areas",
    "locationCoverageBlock",
    "locationMap",
    "faq",
    "gallery",
    "portfolioGallery",
    "offer",
    "offerBlock",
    "pricingBlock",
    "contact",
    "contactBlock",
    "bookingLeadBlock",
    "cta-band",
    "mobileStickyCTA",
    "emptyState",
    "fallbackState",
    "footer",
]);
//# sourceMappingURL=component-role.js.map